export const TRYON_SERVER_URL = process.env.REACT_APP_TRYON_SERVER_URL;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const ADMIN_SHOP_URL = process.env.REACT_APP_ADMIN_SHOP_URL;
export const CREDIT_VALUE = process.env.REACT_APP_CREDIT_VALUE;
export const CASHFREE_PAYMENT_GATEWAY_URL = process.env.REACT_APP_CASHFREE_PAYMENT_GATEWAY_URL;
export const CASHFREE_MODE=process.env.REACT_APP_CASHFREE_MODE
export const MINIMUM_CREDITS_TO_SHOW_BUY_CREDITS_POPUP = process.env.REACT_APP_MINIMUM_CREDITS_TO_SHOW_BUY_CREDITS_POPUP